import React from 'react'
import styled from 'styled-components'
import media from '../../utils/style'
import OutlineButton from '../OutlineButton'

const SplitHeroEl = styled.div`
  position: relative;
  width: 100%;
  background-color: ${(props) => props.theme.colors.grey_slate};
  color: ${(props) => props.theme.colors.white};
  min-height: 230px;
  display: flex;

  ${media.SmallishScreenUp`
    min-height: 336px;
    height: 100%; /* IE fix */
  `};
`

const SplitHeroContent = styled.div`
  padding: 16px 20px;

  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  background-image: linear-gradient(
    0deg,
    ${(props) => props.theme.colors.grey_slate} 0%,
    rgba(41, 42, 43, 0) 86%
  );

  ${media.MediumScreenUp`
    position: static;
    background-image: none;
    flex: 1 0 50%;
    max-width: 50%; /* IE fix */
    display: flex;
    align-items: center;
    padding: 32px;
  `}
`

const SplitHeroContentInner = styled.div`
  line-height: 1.5;
  > * {
    margin-bottom: 0;
  }

  > * + * {
    margin-top: 16px;
  }
`

const SplitHeroHeading = styled.h2`
  max-width: 384px;
  font-size: 20px;
  color: ${(props) => props.theme.colors.white};
  ${media.MediumScreenUp`
    display: block;
    font-size: 28px;
  `};
`

const SplitHeroDescription = styled.div`
  display: none;

  ${media.MediumScreenUp`
    display: block;
  `}
`

const SplitHeroTerms = styled.div`
  display: none;
  font-size: 11px;
  line-height: 1.1;
  font-style: italic;
  opacity: 0.8;

  ${media.MediumScreenUp`
    display: block;
  `}

  > * {
    margin: 0;
  }
`

const SplitHeroOverlay = styled.a`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.5;
`

const SplitHeroAction = styled.div`
  display: none;
  position: relative;
  z-index: 1;
  pointer-events: none;
  padding-top: 10px;

  ${media.MediumScreenUp`
    display: inline-block;
  `}

  * {
    pointer-events: all;
  }
`

const SplitHeroImage = styled.div`
  flex: 1 0 auto;
  background-size: cover;
  background-position: 50% 50%;

  ${media.MediumScreenUp`
    flex: 1 0 50%;
    max-width: 50%; /* IE fix */
  `}
`

export default class SplitHero extends React.PureComponent {
  render() {
    const {
      title,
      description,
      terms,
      callToActionText,
      callToActionLink,
      onMouseDown,
      onClick,
      src
    } = this.props

    return (
      <SplitHeroEl>
        <SplitHeroContent>
          <SplitHeroContentInner>
            <SplitHeroHeading>{title}</SplitHeroHeading>
            {description && (
              <SplitHeroDescription
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            {terms && (
              <SplitHeroTerms>
                {terms.split(/\n/).map((line, i) => (
                  <p key={`line:${i}`}>{line}</p>
                ))}
              </SplitHeroTerms>
            )}
            {callToActionText && (
              <SplitHeroAction>
                <OutlineButton
                  onMouseDown={onMouseDown}
                  onClick={onClick}
                  href={callToActionLink}
                >
                  {callToActionText}
                </OutlineButton>
              </SplitHeroAction>
            )}
          </SplitHeroContentInner>
        </SplitHeroContent>
        <SplitHeroImage style={{ backgroundImage: `url(${src})` }} />
        <SplitHeroOverlay
          href={callToActionLink}
          onMouseDown={onMouseDown}
          onClick={onClick}
        />
      </SplitHeroEl>
    )
  }
}
